import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import QualityReviewInfo from './QualityReviewInfo'
import CobaltHyperLink from '../../typography/CobaltHyperlink'
import ExpandCollapse from '../../../static/images/icon_collapse.svg'
import TimestampVersion from './TimestampVersion'
import HistoryDots from '../../../static/images/questhistory/history_dots.svg'
import ActivityEditEventsList from './ActivityEditEventsList'

import { postLoggingInfo } from '../../../actions/logging'
import { getQuestEventLoggingData } from '../../../utils/logging'
import {
  getHistoryEventText,
  eventExpandable
} from '../../../utils/questhistory'

const StyledHistoryItem = styled.li`
  height: 100%;
  margin-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  pointer-events: ${props => (props.hasMore ? 'auto' : 'none')};
  cursor: ${props => (props.hasMore ? 'pointer' : 'none')};
  border-top: ${props => (props.expanded ? '1px solid #DEDFE0' : 'none')};
  border-bottom: ${props => (props.expanded ? '1px solid #DEDFE0' : 'none')};

  &:hover {
    border-top: 1px solid #dedfe0;
    border-bottom: 1px solid #dedfe0;
  }
`

const IconTextWrapper = styled.div`
  display: flex;
`

const HistoryItemTop = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 39px 0 23px !important;
`

const ExpandCollapseIcon = styled.div`
  background: url(${ExpandCollapse}) no-repeat;
  background-size: 100%;
  width: 15px;
  height: 9px;
  transform: ${props => (props.expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  margin-left: 15px;
`

const HistoryDotsIcon = styled.div`
  background: url(${HistoryDots}) no-repeat;
  height: 20px;
  width: 2px;
  position: absolute;
  left: 33px;
  bottom: -10px;
`

class HistoryItem extends React.Component {
  constructor() {
    super()
    this.state = {
      hovered: false,
      expanded: false
    }

    this.onHoverBound = this.onHover.bind(this)
    this.onLeaveHoverBound = this.onLeaveHover.bind(this)
    this.onToggleExpandClickBound = this.onToggleExpandClick.bind(this)
    this.ref = React.createRef()
  }

  render() {
    const { event } = this.props
    const { expanded } = this.state
    const hasMore = eventExpandable(event)

    if (this.props.hideItem) {
      return null
    }
    return (
      <StyledHistoryItem
        onMouseEnter={this.onHoverBound}
        onMouseLeave={this.onLeaveHoverBound}
        onClick={() => this.onToggleExpandClick(hasMore)}
        hasMore={hasMore}
        expanded={expanded}
        className="history-item"
        innerRef={this.ref}
      >
        <HistoryItemTop>
          <IconTextWrapper>{getHistoryEventText(event)}</IconTextWrapper>
          {hasMore && (this.state.hovered || expanded) ? (
            <CobaltHyperLink style={{ display: 'flex', alignItems: 'center' }}>
              {`${expanded ? 'Hide' : 'Show'} ${hasMore.text}`}
              <ExpandCollapseIcon expanded={expanded} />
            </CobaltHyperLink>
          ) : (
            <TimestampVersion event={event} />
          )}
          {!expanded && <HistoryDotsIcon className="history-dots" />}
        </HistoryItemTop>

        {expanded &&
          (hasMore.type === 'review' ? (
            <QualityReviewInfo event={event} parentRef={this.ref} />
          ) : (
            <ActivityEditEventsList
              changedAttributes={event.metadata.changed_attributes}
              parentRef={this.ref}
            />
          ))}
      </StyledHistoryItem>
    )
  }

  onHover() {
    this.setState(() => ({
      hovered: true
    }))
  }

  onLeaveHover() {
    this.setState(() => ({
      hovered: false
    }))
  }

  onToggleExpandClick(hasMore) {
    // !expanded means click is to open; send analytics event
    const { event, quest } = this.props
    if (!this.state.expanded) {
      if (hasMore.type === 'activity') {
        let loggingData = getQuestEventLoggingData(quest)
        delete loggingData.manager
        delete loggingData.quest_type
        const data = {
          ...loggingData,
          action: 'view_activity_edit'
        }
        this.props.dispatch(postLoggingInfo('quest', data))
      } else {
        const loggingData = getQuestEventLoggingData(quest)
        const data = {
          ...loggingData,
          action: 'view_review_comments_history',
          history_is_review_approved: event.metadata.approved,
          history_quality_reviewer: {
            ...event.metadata.reviewer
          },
          history_quest_version: event.version
        }
        this.props.dispatch(postLoggingInfo('quest', data))
      }
    }
    this.setState(state => ({
      expanded: !state.expanded
    }))
  }
}

HistoryItem.propTypes = {
  event: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  hideItem: PropTypes.bool.isRequired
}

export default HistoryItem



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/HistoryItem.js